// AI Generated Test
import { Component, Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { AccessibilityResultTypeService } from '@client/app/blocks/service/accessibility/result-type.service';

@Component({
    selector: 'accessibility-dashboard-compliance-doughnut',
    standalone: false,
    template: `
        <div class="row">
            <div class="col-38">
                <div class="row">
                    <div class="col-48 pl-3">
                        <notification-change title=""
                                            [digit]="checksWithErrors">
                        </notification-change>
                    </div>
                </div>

                <div class="row">
                    <div class="col-48 pl-6">
                        <accessibility-dashboard-compliance-doughnut-progress-bar [value]="(totalChecks - checksWithErrors)"
                                                                              [max]="totalChecks">
                        </accessibility-dashboard-compliance-doughnut-progress-bar>
                    </div>
                </div>
            </div>
        </div>
    `,
})
export class AccessibilityDashboardComplianceDoughnutComponent implements OnInit {
    @Input() type: any;
    @Input() checks: any;
    @Input() selectedObs!: Observable<any>;

    totalChecks: any;
    checksWithErrors: any;

    constructor (private accessibilityResultTypeService: AccessibilityResultTypeService) {}

    ngOnInit () {
        // Make sure that the summary is properly setup
        this.selectedObs.subscribe((resultType) => {
            this.totalChecks = this.accessibilityResultTypeService.getChecksCount(this.checks, resultType, [this.type]);
            this.checksWithErrors = this.accessibilityResultTypeService.getChecksCount(
                this.checks,
                resultType,
                [this.type],
                true,
            );
        });
    }
}
